import { useEffect, useState } from 'react';
import type { IPractitioner } from '../../../../interfaces/practitioner';
import { fetchJson } from '../../../../../store/fetch';
import { translateKey } from '../../../../../translate';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { ProfileImageWithName } from '../../../episodes/common';

export function ServiceConsumerSupervisorRead(props: { request: { supervisorPractitionerId?: string } }) {
    const [practitioner, setPractitioner] = useState<IPractitioner | null>(null);

    useEffect(() => {
        if (props.request.supervisorPractitionerId) {
            loadPractitioner();
        }
    }, []);

    if (!props.request.supervisorPractitionerId) {
        return null;
    }

    async function loadPractitioner() {
        const url = `/api/practitioners/${props.request.supervisorPractitionerId}`;
        const result = await fetchJson(url, 'GET');

        if (result.json.hasEmployments) {
            setPractitioner(result.json);
        }
    }

    return (
        <>
            <HorizontalFormGroupRead>
                <FormLabel>{translateKey('request.supervisedBy')}</FormLabel>
                <InputContainer>
                    <ProfileImageWithName
                        organization={null}
                        practitioner={practitioner}
                    />
                </InputContainer>
            </HorizontalFormGroupRead>
        </>
    );
}
